<button
  class="padded-top"
  type="button"
  mat-raised-button
  (click)="onExportToExcel()"
>
  <i class="fa fa-file-excel" *ngIf="!exporting"></i>
  <i class="fa fa-spinner fa-spin" *ngIf="exporting"></i>
  Export to Excel
</button>
